import React, { useMemo } from "react";
import { isNumber } from "lodash";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const ExecutorArrivalTimeCellContent: React.FC<
	ExecutorArrivalTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const executorArrivalTimestamp = useMemo(
		() =>
			item?.executorToOrder?.[0]?.additionalFields?.arrivalTime ||
			item?.additionalFields?.transfer?.lastReceivedOrder
				?.executorToOrder?.[0]?.additionalFields?.arrivalTime,
		[
			item?.additionalFields?.transfer?.lastReceivedOrder
				?.executorToOrder,
			item?.executorToOrder,
		],
	);

	const time = useMemo(
		() =>
			item?.orderDate ||
			item?.filledAt ||
			item?.additionalFields?.transfer?.lastReceivedOrder?.filledAt ||
			item?.additionalFields?.transfer?.lastReceivedOrder?.orderDate ||
			1,
		[
			item?.additionalFields?.transfer?.lastReceivedOrder?.filledAt,
			item?.additionalFields?.transfer?.lastReceivedOrder?.orderDate,
			item?.filledAt,
			item?.orderDate,
		],
	);
	const orderTime = useMemo(() => new Date(time).getTime(), [time]);

	const content = useMemo(
		() =>
			isNumber(executorArrivalTimestamp)
				? dateFns.formatTime2(
						Math.max(orderTime, executorArrivalTimestamp),
						"HH:mm:ss",
						{ zeroSeconds: true },
				  )
				: "",
		[dateFns, executorArrivalTimestamp, orderTime],
	);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorArrivalTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutorArrivalTimeCellContent;
